import React from 'react';
import { useProto } from '../../contexts/PrototypeContext';
import { describeCustomerState } from '../../utils/customerState';
import { DeviceFrame } from './DeviceFrame';
import { RegistrationFlow } from './RegistrationFlow';
export function CustomerCanvas() {
  const {
    state,
    discountApplied
  } = useProto();
  const {
    code,
    label
  } = describeCustomerState({
    step: state.step,
    notice: state.notice,
    pageOffer: state.pageOffer,
    config: state.config,
    discountApplied,
    claimed: state.reservation.status === 'claimed'
  });
  return <div className="h-full overflow-auto bg-proto-canvas" data-id="element-279" data-mp="24k5ypybr4m79">
      <div className="flex min-h-full flex-col items-center gap-4 px-6 py-5" data-id="element-280" data-mp="28nc28y7hbza1">
        <p className="flex items-center gap-2 rounded-full bg-white px-3 py-1.5 font-proto text-xs text-proto-ink shadow-sm" aria-live="polite" data-id="element-281" data-mp="2df3tlaygm918">
          <span className="rounded-full bg-proto-accent px-2 py-0.5 text-[11px] font-semibold text-white" data-id="element-282" data-mp="1gwpihu1rghwo">State {code}</span>
          {label}
        </p>
        <DeviceFrame device={state.device} data-id="element-283" data-mp="1hi9g3gbfiede">
          <RegistrationFlow device={state.device} data-id="element-284" data-mp="1hk2n4wpyf0lx" />
        </DeviceFrame>
      </div>
    </div>;
}